import { gql } from "@apollo/client";

export const GET_ARCHIVO_COTIZACION = gql`
query GetEvaluacionArchivoCotizacion($idEvaluacion: Int!) {
  evaluacionArchivoCotizacion (idEvaluacion: $idEvaluacion) {
    idArchivo
    titulo,
    extension,
    contentType,
    archivo
  } 
}
`;